import { Outlet } from "react-router-dom"

const AdminManage = ()=>{
    return(
        <>
            <Outlet/>
        </>
    )
}
export default AdminManage